export function If({ condition, children }) {
  return condition ? children : null;
}
